<template>
    <div class="alert alert-danger ac mt20 e-block not-supported-browser-warning">
        Your browser is not currently supported. Please use the latest version of Chrome, Opera, Firefox, Edge, or Safari.
    </div>
</template>

<script>
const notSupportedBrowserCmp = {
    mounted() {
        let initialLoader = document.getElementById('initialLoader');

        if (initialLoader) {
            initialLoader.style.display = 'none';
        }
    }
};

export default notSupportedBrowserCmp;
</script>

<style lang="css">
.not-supported-browser-warning {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 670px;
    margin-left: -335px;
    font-size: 20px;
}
</style>
